/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Mebi API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CheckEmailDto,
  CheckPhoneDto,
  DeleteAccountDto,
  SetupProfileDto,
  UpdateOrganizerProfileDto,
  UpdatePlayerProfileDto,
  UpdateProfileDto,
  UsersControllerDeleteAccount200,
} from "../model";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type usersControllerGetProfileResponse200 = {
  data: void;
  status: 200;
};

export type usersControllerGetProfileResponseSuccess =
  usersControllerGetProfileResponse200 & {
    headers: Headers;
  };
export type usersControllerGetProfileResponse =
  usersControllerGetProfileResponseSuccess;

export const getUsersControllerGetProfileUrl = () => {
  return `/users/profile`;
};

export const usersControllerGetProfile = async (
  options?: RequestInit,
): Promise<usersControllerGetProfileResponse> => {
  return customInstance<usersControllerGetProfileResponse>(
    getUsersControllerGetProfileUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getUsersControllerGetProfileQueryKey = () => {
  return [`/users/profile`] as const;
};

export const getUsersControllerGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof usersControllerGetProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersControllerGetProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersControllerGetProfile>>
  > = ({ signal }) => usersControllerGetProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerGetProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersControllerGetProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerGetProfile>>
>;
export type UsersControllerGetProfileQueryError = ErrorType<unknown>;

export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetProfile>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetProfile>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersControllerGetProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type usersControllerUpdateProfileResponse200 = {
  data: void;
  status: 200;
};

export type usersControllerUpdateProfileResponseSuccess =
  usersControllerUpdateProfileResponse200 & {
    headers: Headers;
  };
export type usersControllerUpdateProfileResponse =
  usersControllerUpdateProfileResponseSuccess;

export const getUsersControllerUpdateProfileUrl = () => {
  return `/users/profile`;
};

export const usersControllerUpdateProfile = async (
  updateProfileDto: UpdateProfileDto,
  options?: RequestInit,
): Promise<usersControllerUpdateProfileResponse> => {
  return customInstance<usersControllerUpdateProfileResponse>(
    getUsersControllerUpdateProfileUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateProfileDto),
    },
  );
};

export const getUsersControllerUpdateProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
    TError,
    { data: BodyType<UpdateProfileDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
  TError,
  { data: BodyType<UpdateProfileDto> },
  TContext
> => {
  const mutationKey = ["usersControllerUpdateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
    { data: BodyType<UpdateProfileDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerUpdateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerUpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>
>;
export type UsersControllerUpdateProfileMutationBody =
  BodyType<UpdateProfileDto>;
export type UsersControllerUpdateProfileMutationError = ErrorType<unknown>;

export const useUsersControllerUpdateProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
      TError,
      { data: BodyType<UpdateProfileDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
  TError,
  { data: BodyType<UpdateProfileDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerUpdateProfileMutationOptions(options),
    queryClient,
  );
};
export type usersControllerSetupProfileResponse201 = {
  data: void;
  status: 201;
};

export type usersControllerSetupProfileResponseSuccess =
  usersControllerSetupProfileResponse201 & {
    headers: Headers;
  };
export type usersControllerSetupProfileResponse =
  usersControllerSetupProfileResponseSuccess;

export const getUsersControllerSetupProfileUrl = () => {
  return `/users/profile/setup`;
};

/**
 * @summary First-time profile setup after registration
 */
export const usersControllerSetupProfile = async (
  setupProfileDto: SetupProfileDto,
  options?: RequestInit,
): Promise<usersControllerSetupProfileResponse> => {
  return customInstance<usersControllerSetupProfileResponse>(
    getUsersControllerSetupProfileUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setupProfileDto),
    },
  );
};

export const getUsersControllerSetupProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerSetupProfile>>,
    TError,
    { data: BodyType<SetupProfileDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerSetupProfile>>,
  TError,
  { data: BodyType<SetupProfileDto> },
  TContext
> => {
  const mutationKey = ["usersControllerSetupProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerSetupProfile>>,
    { data: BodyType<SetupProfileDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerSetupProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerSetupProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerSetupProfile>>
>;
export type UsersControllerSetupProfileMutationBody = BodyType<SetupProfileDto>;
export type UsersControllerSetupProfileMutationError = ErrorType<unknown>;

/**
 * @summary First-time profile setup after registration
 */
export const useUsersControllerSetupProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerSetupProfile>>,
      TError,
      { data: BodyType<SetupProfileDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerSetupProfile>>,
  TError,
  { data: BodyType<SetupProfileDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerSetupProfileMutationOptions(options),
    queryClient,
  );
};
export type usersControllerUpdatePlayerProfileResponse200 = {
  data: void;
  status: 200;
};

export type usersControllerUpdatePlayerProfileResponseSuccess =
  usersControllerUpdatePlayerProfileResponse200 & {
    headers: Headers;
  };
export type usersControllerUpdatePlayerProfileResponse =
  usersControllerUpdatePlayerProfileResponseSuccess;

export const getUsersControllerUpdatePlayerProfileUrl = () => {
  return `/users/profile/player`;
};

export const usersControllerUpdatePlayerProfile = async (
  updatePlayerProfileDto: UpdatePlayerProfileDto,
  options?: RequestInit,
): Promise<usersControllerUpdatePlayerProfileResponse> => {
  return customInstance<usersControllerUpdatePlayerProfileResponse>(
    getUsersControllerUpdatePlayerProfileUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updatePlayerProfileDto),
    },
  );
};

export const getUsersControllerUpdatePlayerProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>,
    TError,
    { data: BodyType<UpdatePlayerProfileDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>,
  TError,
  { data: BodyType<UpdatePlayerProfileDto> },
  TContext
> => {
  const mutationKey = ["usersControllerUpdatePlayerProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>,
    { data: BodyType<UpdatePlayerProfileDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerUpdatePlayerProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerUpdatePlayerProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>
>;
export type UsersControllerUpdatePlayerProfileMutationBody =
  BodyType<UpdatePlayerProfileDto>;
export type UsersControllerUpdatePlayerProfileMutationError =
  ErrorType<unknown>;

export const useUsersControllerUpdatePlayerProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>,
      TError,
      { data: BodyType<UpdatePlayerProfileDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerUpdatePlayerProfile>>,
  TError,
  { data: BodyType<UpdatePlayerProfileDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerUpdatePlayerProfileMutationOptions(options),
    queryClient,
  );
};
export type usersControllerUpdateOrganizerProfileResponse200 = {
  data: void;
  status: 200;
};

export type usersControllerUpdateOrganizerProfileResponseSuccess =
  usersControllerUpdateOrganizerProfileResponse200 & {
    headers: Headers;
  };
export type usersControllerUpdateOrganizerProfileResponse =
  usersControllerUpdateOrganizerProfileResponseSuccess;

export const getUsersControllerUpdateOrganizerProfileUrl = () => {
  return `/users/profile/organizer`;
};

export const usersControllerUpdateOrganizerProfile = async (
  updateOrganizerProfileDto: UpdateOrganizerProfileDto,
  options?: RequestInit,
): Promise<usersControllerUpdateOrganizerProfileResponse> => {
  return customInstance<usersControllerUpdateOrganizerProfileResponse>(
    getUsersControllerUpdateOrganizerProfileUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateOrganizerProfileDto),
    },
  );
};

export const getUsersControllerUpdateOrganizerProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>,
    TError,
    { data: BodyType<UpdateOrganizerProfileDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>,
  TError,
  { data: BodyType<UpdateOrganizerProfileDto> },
  TContext
> => {
  const mutationKey = ["usersControllerUpdateOrganizerProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>,
    { data: BodyType<UpdateOrganizerProfileDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerUpdateOrganizerProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerUpdateOrganizerProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>
>;
export type UsersControllerUpdateOrganizerProfileMutationBody =
  BodyType<UpdateOrganizerProfileDto>;
export type UsersControllerUpdateOrganizerProfileMutationError =
  ErrorType<unknown>;

export const useUsersControllerUpdateOrganizerProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>,
      TError,
      { data: BodyType<UpdateOrganizerProfileDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerUpdateOrganizerProfile>>,
  TError,
  { data: BodyType<UpdateOrganizerProfileDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerUpdateOrganizerProfileMutationOptions(options),
    queryClient,
  );
};
export type usersControllerDeleteAccountResponse200 = {
  data: UsersControllerDeleteAccount200;
  status: 200;
};

export type usersControllerDeleteAccountResponse400 = {
  data: void;
  status: 400;
};

export type usersControllerDeleteAccountResponse401 = {
  data: void;
  status: 401;
};

export type usersControllerDeleteAccountResponseSuccess =
  usersControllerDeleteAccountResponse200 & {
    headers: Headers;
  };
export type usersControllerDeleteAccountResponseError = (
  | usersControllerDeleteAccountResponse400
  | usersControllerDeleteAccountResponse401
) & {
  headers: Headers;
};

export type usersControllerDeleteAccountResponse =
  | usersControllerDeleteAccountResponseSuccess
  | usersControllerDeleteAccountResponseError;

export const getUsersControllerDeleteAccountUrl = () => {
  return `/users/delete-account`;
};

/**
 * @summary Delete the current user account after nickname confirmation
 */
export const usersControllerDeleteAccount = async (
  deleteAccountDto: DeleteAccountDto,
  options?: RequestInit,
): Promise<usersControllerDeleteAccountResponse> => {
  return customInstance<usersControllerDeleteAccountResponse>(
    getUsersControllerDeleteAccountUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(deleteAccountDto),
    },
  );
};

export const getUsersControllerDeleteAccountMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerDeleteAccount>>,
    TError,
    { data: BodyType<DeleteAccountDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerDeleteAccount>>,
  TError,
  { data: BodyType<DeleteAccountDto> },
  TContext
> => {
  const mutationKey = ["usersControllerDeleteAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerDeleteAccount>>,
    { data: BodyType<DeleteAccountDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerDeleteAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerDeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerDeleteAccount>>
>;
export type UsersControllerDeleteAccountMutationBody =
  BodyType<DeleteAccountDto>;
export type UsersControllerDeleteAccountMutationError = ErrorType<void>;

/**
 * @summary Delete the current user account after nickname confirmation
 */
export const useUsersControllerDeleteAccount = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerDeleteAccount>>,
      TError,
      { data: BodyType<DeleteAccountDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerDeleteAccount>>,
  TError,
  { data: BodyType<DeleteAccountDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerDeleteAccountMutationOptions(options),
    queryClient,
  );
};
export type usersControllerFindByPhoneResponse201 = {
  data: void;
  status: 201;
};

export type usersControllerFindByPhoneResponseSuccess =
  usersControllerFindByPhoneResponse201 & {
    headers: Headers;
  };
export type usersControllerFindByPhoneResponse =
  usersControllerFindByPhoneResponseSuccess;

export const getUsersControllerFindByPhoneUrl = () => {
  return `/users/find-by-phone`;
};

/**
 * @summary Find user by phone number
 */
export const usersControllerFindByPhone = async (
  checkPhoneDto: CheckPhoneDto,
  options?: RequestInit,
): Promise<usersControllerFindByPhoneResponse> => {
  return customInstance<usersControllerFindByPhoneResponse>(
    getUsersControllerFindByPhoneUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(checkPhoneDto),
    },
  );
};

export const getUsersControllerFindByPhoneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerFindByPhone>>,
    TError,
    { data: BodyType<CheckPhoneDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerFindByPhone>>,
  TError,
  { data: BodyType<CheckPhoneDto> },
  TContext
> => {
  const mutationKey = ["usersControllerFindByPhone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerFindByPhone>>,
    { data: BodyType<CheckPhoneDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerFindByPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerFindByPhoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerFindByPhone>>
>;
export type UsersControllerFindByPhoneMutationBody = BodyType<CheckPhoneDto>;
export type UsersControllerFindByPhoneMutationError = ErrorType<unknown>;

/**
 * @summary Find user by phone number
 */
export const useUsersControllerFindByPhone = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerFindByPhone>>,
      TError,
      { data: BodyType<CheckPhoneDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerFindByPhone>>,
  TError,
  { data: BodyType<CheckPhoneDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerFindByPhoneMutationOptions(options),
    queryClient,
  );
};
export type usersControllerCheckEmailResponse201 = {
  data: void;
  status: 201;
};

export type usersControllerCheckEmailResponseSuccess =
  usersControllerCheckEmailResponse201 & {
    headers: Headers;
  };
export type usersControllerCheckEmailResponse =
  usersControllerCheckEmailResponseSuccess;

export const getUsersControllerCheckEmailUrl = () => {
  return `/users/check-email`;
};

/**
 * @summary Check if email exists
 */
export const usersControllerCheckEmail = async (
  checkEmailDto: CheckEmailDto,
  options?: RequestInit,
): Promise<usersControllerCheckEmailResponse> => {
  return customInstance<usersControllerCheckEmailResponse>(
    getUsersControllerCheckEmailUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(checkEmailDto),
    },
  );
};

export const getUsersControllerCheckEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerCheckEmail>>,
    TError,
    { data: BodyType<CheckEmailDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerCheckEmail>>,
  TError,
  { data: BodyType<CheckEmailDto> },
  TContext
> => {
  const mutationKey = ["usersControllerCheckEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerCheckEmail>>,
    { data: BodyType<CheckEmailDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerCheckEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerCheckEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerCheckEmail>>
>;
export type UsersControllerCheckEmailMutationBody = BodyType<CheckEmailDto>;
export type UsersControllerCheckEmailMutationError = ErrorType<unknown>;

/**
 * @summary Check if email exists
 */
export const useUsersControllerCheckEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerCheckEmail>>,
      TError,
      { data: BodyType<CheckEmailDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerCheckEmail>>,
  TError,
  { data: BodyType<CheckEmailDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerCheckEmailMutationOptions(options),
    queryClient,
  );
};
export type usersControllerCheckPhoneResponse201 = {
  data: void;
  status: 201;
};

export type usersControllerCheckPhoneResponseSuccess =
  usersControllerCheckPhoneResponse201 & {
    headers: Headers;
  };
export type usersControllerCheckPhoneResponse =
  usersControllerCheckPhoneResponseSuccess;

export const getUsersControllerCheckPhoneUrl = () => {
  return `/users/check-phone`;
};

/**
 * @summary Check if phone exists
 */
export const usersControllerCheckPhone = async (
  checkPhoneDto: CheckPhoneDto,
  options?: RequestInit,
): Promise<usersControllerCheckPhoneResponse> => {
  return customInstance<usersControllerCheckPhoneResponse>(
    getUsersControllerCheckPhoneUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(checkPhoneDto),
    },
  );
};

export const getUsersControllerCheckPhoneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerCheckPhone>>,
    TError,
    { data: BodyType<CheckPhoneDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerCheckPhone>>,
  TError,
  { data: BodyType<CheckPhoneDto> },
  TContext
> => {
  const mutationKey = ["usersControllerCheckPhone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerCheckPhone>>,
    { data: BodyType<CheckPhoneDto> }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerCheckPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerCheckPhoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerCheckPhone>>
>;
export type UsersControllerCheckPhoneMutationBody = BodyType<CheckPhoneDto>;
export type UsersControllerCheckPhoneMutationError = ErrorType<unknown>;

/**
 * @summary Check if phone exists
 */
export const useUsersControllerCheckPhone = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerCheckPhone>>,
      TError,
      { data: BodyType<CheckPhoneDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerCheckPhone>>,
  TError,
  { data: BodyType<CheckPhoneDto> },
  TContext
> => {
  return useMutation(
    getUsersControllerCheckPhoneMutationOptions(options),
    queryClient,
  );
};
